module.exports = "/_next/static/images/minus-gray400-a1ab8746280eff44c612019d2937e22c.svg";